import React from "react";
import { Instagram, Facebook, MapPin, Clock } from "lucide-react";
import { CONTACT, HOURS, IMAGES } from "../../lib/constants";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-bordo text-white" data-testid="footer">
      {/* Top gold accent */}
      <div className="h-1 bg-gradient-to-r from-transparent via-gold to-transparent" />

      <div className="max-w-5xl mx-auto px-6 md:px-10 py-14 text-center">
        <img
          src={IMAGES.logo}
          alt="O Padrinho"
          className="h-20 md:h-24 w-auto mx-auto mb-6 drop-shadow-lg"
          data-testid="footer-logo"
        />

        <div className="gold-ornament mb-7 opacity-80" />

        <div className="flex items-center justify-center gap-5 mb-7">
          <a
            href={CONTACT.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            className="w-12 h-12 rounded-full bg-white/10 hover:bg-gold hover:text-bordo flex items-center justify-center transition-all border border-white/20"
            data-testid="footer-instagram"
          >
            <Instagram size={20} />
          </a>
          <a
            href={CONTACT.facebookUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            className="w-12 h-12 rounded-full bg-white/10 hover:bg-gold hover:text-bordo flex items-center justify-center transition-all border border-white/20"
            data-testid="footer-facebook"
          >
            <Facebook size={20} fill="currentColor" strokeWidth={0} />
          </a>
        </div>

        <div className="grid sm:grid-cols-2 gap-5 max-w-2xl mx-auto mb-9 text-sm text-white/85">
          <div className="flex items-start gap-2 justify-center sm:justify-start text-left">
            <MapPin size={16} className="text-gold mt-0.5 flex-shrink-0" />
            <span>{CONTACT.addressShort}</span>
          </div>
          <div className="flex items-start gap-2 justify-center sm:justify-start text-left">
            <Clock size={16} className="text-gold mt-0.5 flex-shrink-0" />
            <div>
              {HOURS.map((h, i) => (
                <div key={i} className="leading-snug">
                  <span className="text-gold/90">{h.days}:</span> {h.time}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="pt-7 border-t border-white/15">
          <p className="text-xs md:text-sm text-white/70" data-testid="footer-copyright">
            © {year} Restaurante e Lanchonete O Padrinho — Sorriso, MT. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
